
import React from "react";
import { View } from "react-native";

import isFunction from "lodash/isFunction";
import styles from "./style"
import LoadingComp from "../LoadingComp";

function DataLoader(props) {

    const {
        gridData = [],
        gapBetweenGrids = 10,
        containerStyling,
        isBordered = true,
        componentsMap
    } = props

    const renderLoaderComp = (elem) => {
        if (Array.isArray(elem)) {
            return (
                <View style={{ flexDirection: "row" }}>
                    {elem?.map((item, ind) => {
                        return (
                            getItem(item, ind === elem?.length - 1 ? 0 : gapBetweenGrids)
                        )
                    })}
                </View>
            )
        }
        return getItem(elem)
    }

    const getItem = (item, gap) => {
        if (item?.component && isFunction(componentsMap[item?.component])) {
            return componentsMap[item?.component]()
        }
        return (
            <>
                <View
                    style={{
                        flex: item?.flex || 1,
                        width: item?.width || "100%"
                    }}
                >
                    <LoadingComp
                        backgroundColor={item?.backgroundColor}
                        foregroundColor={item?.foregroundColor}
                        width={"100%"}
                        height={item?.height} />
                </View>
                <View style={{ marginRight: gap || 0 }} />
            </>

        )
    }

    return (
        <View style={[
            isBordered && styles.borderedStyle,
            containerStyling
        ]}>
            {gridData?.map(renderLoaderComp)}
        </View >
    )
}
export default DataLoader;